<template>
    <div>
        <div v-if="inspections && inspections.length>0" class="card hide-while-loading">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Tenant</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr v-for="inspection in inspections" :key="inspection.id">

                                <td :class="{'text-gray-400' : inspection.deleted_at != null}">
                                    {{ inspection.date | localeUnawareDatetime }}
                                </td>

                                <td :class="{'text-gray-400' : inspection.deleted_at != null}">
                                    {{ inspection.type }}
                                </td>

                                <td :class="{'text-gray-400' : inspection.deleted_at != null}">
                                    {{ inspection.tenant_name }}
                                </td>

                                <td>
                                    <div class="relative">{{ inspection.status | titlecase }}
                                        <badge v-if="inspection.archived_at" class="bg-yellow-100 text-yellow-600">
                                            Archived
                                        </badge>
                                        <badge v-else-if="inspection.deleted_at" class="bg-red-100 text-red-600">
                                            Deleted
                                        </badge>
                                    </div>
                                </td>

                                <td class="text-right">
                                    <button class="text-brand hover:text-red-500 font-medium"
                                            v-if="inspection.deleted_at" @click.prevent="restoreDeletedInspection(inspection.id)">
                                        Restore
                                    </button>
                                    <a v-else
                                       class="py-1.5 font-medium rounded-full text-indigo-600 hover:text-indigo-400"
                                       :href="'/inspections/' + inspection .id"
                                       @click.prevent="goToInspection(inspection.id)">View
                                    </a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <simple-pagination
                    v-if="paginationData && paginationData.total > 0"
                    :meta="paginationData"
                    per-page="10"
                    :current-page="paginationData.current_page"
                    padding="3"
                    @page-changed="fetchInspections">
                </simple-pagination>

            </div>
        </div>

        <!--Empty View displayed if there are no inspections -->
        <div v-else-if="!loading && inspections.length <= 0" class="card hide-while-loading text-center">
            <div class="card-body">
                <h4 class="card-title">No Inspections</h4>
                <div class="text-center">
                    <span class="">This asset has no inspections associated with it yet.</span>
                </div>
            </div>
        </div>

        <div v-else-if="loading"
             class="flex justify-center items-center w-full p-20">
            <div class="flex flex-col items-center">
                <h2 class="text-xl font-normal text-gray-400 my-4 select-none flex align-items-center">
                    <icon-refresh class="h-8 w-8 text-indigo-600 animate-spin mr-2"/>
                    Loading...
                </h2>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: "AssetInspectionList",

    props: {
        asset: {
            type: Object,
            required: true,
        }
    },

    data () {
        return {
            loading: false,
            inspections: [],
            paginationData: {},
        };
    },

    mounted () {
        this.fetchInspections();
    },

    methods: {
        goToInspection (inspectionId) {
            window.open("/inspections/" + inspectionId, "_blank");
        },

        fetchInspections (pagination = {}) {
            this.loading = true;
            axios.get("/inspections/all", {
                params: {
                    asset_filter: this.asset.id,
                    with_trashed: true,
                    archived_filter: "both",
                    page: pagination.pageNumber,
                    per_page: 20,
                    sort: {date: "desc"}
                }
            }).then((response) => {
                const {data, ...paginationData} = response.data;
                this.inspections = data;
                this.paginationData = paginationData.meta;
                this.loading = false;
            }).catch((error) => {
                this.loading = false;
                toastr.error("Could not fetch inspections: " + error.message);
            });
        },

        restoreDeletedInspection (inspectionId) {
            App.patch("/inspections/" + inspectionId + "/restore", new AppForm({}))
            .then((response) => {
                let index = this.inspections.findIndex(i => i.id === response.id);
                this.inspections.splice(index, 1, response);
                toastr.success("Inspection restored!");
            })
            .catch(() => {
                toastr.error("Could not restore inspection!");
            });
        },

    },
};
</script>
